module.exports = __webpack_public_path__ + "static/media/flash.cde21d0e.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/image/scene/flash.mp4
// module id = 767
// module chunks = 0